import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-home-alt",
  "use": "icon-home-alt-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol role=\"img\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" aria-labelledby=\"homeAltIconTitle\" stroke=\"#000000\" stroke-width=\"2\" stroke-linecap=\"square\" stroke-linejoin=\"miter\" fill=\"none\" id=\"icon-home-alt\"> <title id=\"icon-home-alt_homeAltIconTitle\">Home</title> <path d=\"M3 10.182V22h18V10.182L12 2z\" /> <rect width=\"6\" height=\"8\" x=\"9\" y=\"14\" /> </symbol>"
});
var result = sprite.add(symbol);
export default symbol